import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ngx-show-preview-files',
  templateUrl: './show-preview-files.component.html',
  styleUrls: ['./show-preview-files.component.scss'],
})
export class ShowPreviewFilesComponent implements OnInit {
  @Input() url: string;
  @Input() is_render = false;

  typeFile = '';

  constructor(
    protected ref: NbDialogRef<ShowPreviewFilesComponent>,
    protected sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.getTypeFile();
  }

  downloadRender() {
    this.ref.close('download-render');
  }

  dismiss() {
    this.ref.close();
  }

  getTypeFile() {
    const imageExtensions = ['jpg', 'jpeg', 'png'];
    const wordExtensions = ['docx', 'doc'];
    for (const imageExtension of imageExtensions) if (this.url.search(imageExtension) !== -1) return this.typeFile = 'image';
    for (const wordExtension of wordExtensions) if (this.url.search(wordExtension) !== -1) return this.typeFile = 'word';
    if (this.url.search('pdf') !== -1) return this.typeFile = 'pdf';
    this.typeFile = 'error';
  }

  getUrlWord() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/gview?url=${this.url}&embedded=true`);
  }

  getUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
